import { Select, Space, Spin, Tag, Row, Input, Divider } from "antd";
import apiAction from "../../ajax/service";
import { useEffect, useState } from "react";
import { debounce, joinObjectValues } from "../../helpers/helper";
import { CheckSquareTwoTone } from "@ant-design/icons";
import isEqual from "lodash/isEqual";

const SearchSelect = ({
  field,
  onChange,
  placeholder,
  extras,
  selectedIds,
  additionalFieldFilters = {},
  labelFields = ["name"],
  keyField = "id",
  showSelected = false,
  value,
  selectedExtra = null,
  label = {},
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState(undefined);
  const [selectedValues, setSelectedValues] = useState([]);
  const [labels, setLabels] = useState({});
  const [open, setOpen] = useState(false);

  if (!selectedIds) {
    selectedIds = value;
  }

  useEffect(() => {
    if (Object.keys(labels).length == 0)
      setLabels((prev) => (isEqual(prev, label) ? prev : label));
    if (selectedValues.length == 0 && value?.length > 0)
      setSelectedValues((prev) => (isEqual(prev, value) ? prev : value));
  }, [label, value]);

  const handleClose = () => {
    setOpen(false);
    setSearchValue('');
    setOptions([]);
  };

  const onSearch = async (input) => {
    setSearchValue(input == "" ? undefined : input);
    if (input.length < 3) return;
    setLoading(true);

    const data = await apiAction(
      "filters",
      {
        field,
        filters: {
          withKey: true,
          [`name__contains`]: input,
        },
      },
      "getUniqueInField"
    );
    setLoading(false);
    setOptions(
      data.map((item) => ({
        label: joinObjectValues(item, labelFields),
        key: item[keyField],
        value: item[keyField],
        onlyOneAgreement: item.onlyOneAgreement || false,
      }))
    );
  };

  return (
    <>
      <Select
        id="custom-select"
        open={open}
        onDropdownVisibleChange={(visible) => { if (visible) setOpen(true); }}
        allowClear={searchValue ? true : false}
        onClear={()=>{setSearchValue('')}}
        filterOption={false}
        style={{
          width: "100%",
        }}
        placeholder={placeholder}
        showSearch
        searchValue={searchValue}
        optionLabelProp="label"
        labelInValue={showSelected ? true : false}
        onSearch={(input) => debounce(onSearch(input), 2000)}
        notFoundContent={loading ? <Spin size="small" /> : null}
        loading={loading}
        onChange={(value, _) => {
          if(!value) return
          if (showSelected) {
            const cleanedValues = [
              ...new Set([...selectedValues, value.value]),
            ];
            labels[value.value] = value.label;
            setLabels(labels);
            setSelectedValues(cleanedValues);
            onChange(cleanedValues);
          } else {
            onChange(value);
          }
        }}
        value={searchValue}
        dropdownRender={(menu) => (
          <div>
            <div
              onMouseDown={(e) => e.preventDefault()}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "6px 10px",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                {loading ? "Searching..." : `${options.length} found`}
              </span>
              <button
                onMouseDown={(e) => e.preventDefault()}
                onClick={handleClose}
                style={{
                  cursor: "pointer",
                  border: "none",
                  background: "transparent",
                  color: "#8c8c8c",
                  fontSize: 12,
                  lineHeight: 1,
                  padding: "2px 4px",
                  borderRadius: 4,
                }}
              >
                ✕
              </button>
            </div>
            {menu}
          </div>
        )}
      >
        {" "}
        {searchValue &&
          searchValue.length &&
          options.map((it) => (
            <Select.Option key={it.key} value={it.key} label={it.label}>
              <div>
                <span>{it.label}</span>{" "}
                {selectedIds && new Set(selectedIds)?.has(it.value) ? (
                  <CheckSquareTwoTone twoToneColor="#52c41a" />
                ) : null}
                {extras &&
                  Object.keys(extras).map((item) => extras[item](it.key))}
              </div>
            </Select.Option>
          ))}
      </Select>
      {showSelected && (
        <Row className="flex flex-wrap gap-2 p-3 mt-2 bg-gray-50 rounded-lg border border-gray-200 min-h-[44px] max-h-[200px] overflow-y-auto">
          {selectedValues && selectedValues.length > 0 ? (
            selectedValues.map((id) => (
              <Tag
                key={id}
                color="#108ee9"
                variant="solid"
                closable
                onClose={() => {
                  const newSelectedValues = selectedValues.filter(
                    (item) => item != id
                  );
                  delete labels[id];
                  setSelectedValues(newSelectedValues);
                  onChange(newSelectedValues);
                }}
                className="inline-flex items-center whitespace-nowrap gap-1 p-1"
              >
                {labels[id]}
                {
                  selectedExtra ? selectedExtra(id) : <></>
                }
              </Tag>
            ))
          ) : (
            <span className="text-gray-400 text-sm italic">
              No items selected
            </span>
          )}
        </Row>
      )}
    </>
  );
};

export default SearchSelect;
